module.exports = __webpack_public_path__ + "img/advantage-item04.987775e0.png";